import { render } from "./SavePolicy.vue?vue&type=template&id=59fed9d3&scoped=true"
import script from "./SavePolicy.vue?vue&type=script&lang=js"
export * from "./SavePolicy.vue?vue&type=script&lang=js"

import "./SavePolicy.vue?vue&type=style&index=0&id=59fed9d3&lang=scss&scoped=true"

import exportComponent from "/opt/lampp/htdocs/gslhrm/v6061/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59fed9d3"]])

export default __exports__